// these two constants are the same as in `templates/clientMetrics` file
const PERFORMANCE_MARK_PREFIX = 'SM'
const PERFORMANCE_MARK_DELIMITER = '|'

/*
`SM` means 'StatusMoney'
`TTI` means 'time to interactive'
`FMP` means 'first meaningful paint'
*/
export const PERF_MARKS = {
  begin: 'begin',
  blockTTI: 'block-tti',
  pageFMP: 'page-fmp',
}

const NOOP = () => {}

function wrapPerfHelper (func: (markName: string, resourceName?: string, from?: string) => void) {
  return !!window.performance.mark ? func : NOOP
}

const createMark = (markName: string, resourceName?: string) => {
  const names = [markName]
  if (resourceName) {
    names.push(resourceName)

  }

  return `${ PERFORMANCE_MARK_PREFIX } ${ names.join(PERFORMANCE_MARK_DELIMITER) }`
}

export const perfMark = wrapPerfHelper((name: string) => {
  performance.mark(createMark(name))
})

export const perfMeasure = wrapPerfHelper((markName: string, resourceName: string, from: string = PERF_MARKS.begin) => {
  const measureName = createMark(markName, resourceName)

  performance.mark(measureName)
  performance.measure(measureName, createMark(from), measureName)
})
